const MAX_TOOLTIP_SHOWS_PER_PAGE = 3;

export const DYNAMIC_PHONE_TOOLTIP_DURATION_MS = 5_000;

export const DYNAMIC_PHONE_TOOLTIP_TEXT = 'Телефон меняется раз в несколько дней — можете не сохранять.';

export const DYNAMIC_PHONE_ERROR_TEXT = 'Что-то пошло не так, попробуйте позже';

let shownCount = 0;

/** Счётчик живёт до перезагрузки страницы; клики по разным офферам делят лимит */
export function takeDynamicPhoneTooltipShow(): boolean {
  if (shownCount >= MAX_TOOLTIP_SHOWS_PER_PAGE) {
    return false;
  }

  shownCount += 1;

  return true;
}

export function resetDynamicPhoneTooltipShows(): void {
  shownCount = 0;
}
